var LONG_TITLE_LENGTH = 28;
export var isLongTitle = function (title) { return title.length > LONG_TITLE_LENGTH; };
//# sourceMappingURL=helpers.js.map